const SOC_THRESHOLD   = 20
const SOH_THRESHOLD   = 20
const SPEED_THRESHOLD = 40

const BAJAJ_OEMS = ['Bajaj']
const SOH_OEMS   = ['Euler', 'Bajaj']

export const ALERT_DEFS = [
  { key: 'harshBraking', label: 'Harsh Braking',      oem: 'Bajaj',        color: '#dc2626', bg: '#fee2e2', border: '#fca5a5' },
  { key: 'harshAccel',   label: 'Harsh Acceleration',  oem: 'Bajaj',        color: '#f97316', bg: '#ffedd5', border: '#fdba74' },
  { key: 'lowSoc',       label: 'Low SoC',             oem: null,           color: '#eab308', bg: '#fef9c3', border: '#fde047' },
  { key: 'lowSoh',       label: 'Low SoH',             oem: 'Euler, Bajaj', color: '#8b5cf6', bg: '#ede9fe', border: '#c4b5fd' },
  { key: 'overspeeding', label: 'Overspeeding',        oem: null,           color: '#ef4444', bg: '#fee2e2', border: '#fca5a5' },
]

export function getVehicleAlerts(v) {
  const types = []
  if (BAJAJ_OEMS.includes(v.oem) && v.hbi === true)       types.push('harshBraking')
  if (BAJAJ_OEMS.includes(v.oem) && v.hai === true)       types.push('harshAccel')
  if (v.soc != null && v.soc < SOC_THRESHOLD)             types.push('lowSoc')
  if (SOH_OEMS.includes(v.oem) && v.soh != null && v.soh < SOH_THRESHOLD) types.push('lowSoh')
  if (v.csp != null && v.csp > SPEED_THRESHOLD)           types.push('overspeeding')
  return types
}

export function isAlertVehicle(v) {
  return getVehicleAlerts(v).length > 0
}
